@let menuItem = item();
@if (menuItem) {
  <div
    class="content-list-item mix-list-item"
    [ngStyle]="menuItem.style"
    [ngClass]="menuItem.styleClass"
  >
    @if (displayPlayButton()) {
      <div class="button-column">
        <pv2-round-play-button
          (buttonClicked)="playItem()"
          [hint]="menuItem.title ?? 'Play Now'"
          [backgroundImage]="menuItem.backgroundImage"
          [eventSource]="eventSource()"
        >
        </pv2-round-play-button>
      </div>
    }
    <div class="info-column">
      @if (menuItem.routerLink) {
        <a [routerLink]="menuItem.routerLink">
          <ng-container *ngTemplateOutlet="info"></ng-container>
        </a>
      } @else {
        <ng-container *ngTemplateOutlet="info"></ng-container>
      }
    </div>
    @if (displayDuration() && menuItem.duration) {
      <div class="count-column hide-on-mobile">
        {{ menuItem.duration | hoursOrMinutes }}
      </div>
    }

    <ng-template #info>
      <div class="info-container">
        <div class="content-name">{{ menuItem.name }}</div>
        <div class="content-tag-line">{{ menuItem.tagLine }}</div>
        <div class="content-host-name">{{ menuItem.thirdLine }}</div>
      </div>
    </ng-template>
  </div>
}
